import { 
  ROUTER_CPU_MEMORY_API_LOADING,
  SAVE_ROUTER_CPU_MEMORY_GRAPH
 } from "../../constants/graphConstants/connectedClientsGraphConstants";

 export const routerCpuAndMemoryUtilisationReducer = (
  state = { 
    traffic: [],
    routerInfo : {},
    loading : false,
    connectionStats : [],
    routerParams : [],
    events : [],
    routerDemandStats : [] 
  },
  action
) => {
    switch (action.type) {
        case ROUTER_CPU_MEMORY_API_LOADING:
          return {
            ...state,
            traffic: [],
            routerInfo : {},
            connectionStats : [],
            routerParams : [],
            events : [],
            routerDemandStats : [], 
            loading: action.payload,
          };
        case SAVE_ROUTER_CPU_MEMORY_GRAPH:
          return {
            ...state,
            loading: false,
            ...action.payload,
          };
        default:
          return state;
      }
 }